<template src="./additionalPage.html"></template>

<script>
import reportMixin from '../../../../../js/reportMixin';
import reportEndpoints from '../../../reports.endpoints';


export default {
    name: 'additional-page',
    props: ['reportTitle'],
    mixins: [reportMixin],
    data() {
        return {
            additionalReportTableActions: [
                {
                    text: 'Download',
                },
                {
                    text: 'Delete',
                },
            ],
            dto: {},
			additionalReportsTableSortBy: {
				columns: [{ field: 'FileName', direction: 'Ascending'}]
			},
            selectedReport: {},
            additionalReportsTableItems: []
        }
    },
    computed: {
        session() {
            return this.$store.state.SessionsModule.Session;
        }
    },
    methods: {
        getAdditionalReports() {
            return reportEndpoints.getAdditionalReports(this.session.SessionID)
                .then((response) => {
                    this.additionalReportsTableItems = response;
                })      
        },
        fileUploaded(e) {
            let uploadedFile = e.target.files[0];

            let fileExtension = uploadedFile.type.replace(/(.*)\//g, '');
            this.dto.FilePath = uploadedFile.name;    

            var reader = new FileReader();

            reader.onload = (e) => {              
                this.dto.FileContentBase64 = reader.result;
                reportEndpoints.createAdditionalReport(this.dto)
                    .then((response) => {
                        this.getAdditionalReports();
                    })
            };

            reader.readAsDataURL(uploadedFile);
            
        },
        additionalReportTableActionOnClick(args) {
            if (args.item.text === 'Download') {
                return reportEndpoints.downloadAddtionalReport(this.selectedReport.rowData.ReportID)
                .then((response) => {
                    DMUtils.downloadAjaxResponseAsFile(response);
                }) 
                 
            } else if (args.item.text === 'Delete') {
                const message = 'Are you sure you want to delete this report?';
                const title = 'Confirm';
                const confirmCallback = this.deleteAdditionalReport;
                
                DMUtils.openApplicationModal('dmConfirmModal', {
                    title: title,
                    message: message,
                    confirmCallback: confirmCallback,
                    confirmText: 'Yes',
                    denyText: 'Cancel',
                });
            }
        },
        deleteAdditionalReport() {
            this.dto.ReportID = this.selectedReport.rowData.ReportID;
            reportEndpoints.deleteAdditionalReport(this.dto)
                .then((response) => {
                    this.getAdditionalReports();
                })
        },
        additionalReportTableRowOnClick(args) {
			this.selectedReport = args;
		},
    },
    created() {
        this.getAdditionalReports();
        this.additionalReportsTableColumns = [
            {
                type: 'iconTemplate',
                iconName: 'ellipsis',
                ellipsisActions: this.additionalReportTableActions,
                iconOnClick: this.additionalReportTableActionOnClick,
                width: '55px',
            },
            {
                key: 'FilePath',
                label: 'File Name',
                textAlign: 'Left',
            },
        ];
        this.dto.SessionID = this.session.SessionID;
    },
}
</script>